import React, { useEffect, useState, Fragment, lazy } from 'react';
import {Switch} from 'react-router';
import { localStorageClean, localStorageSet } from '../../utils/storage';
import { Auth } from 'aws-amplify';
import { rolesConfig } from '../../config/roles';
import PrivateRoute from './PrivateRoute';
import ROUTES from '../../routes';
import helpers from '../../utils/helpers';

const detailComponents: any = {
  Solicitudes: lazy(() => import('../../scenes/Solicitudes')),
  DetalleSolicitud: lazy(() => import('../../scenes/Solicitudes/scenes/detallesolicitud')),
  Distribucion : lazy(() => import('../../scenes/Distribucion')),
  SupervisorSolicitud : lazy(() => import('../../scenes/SupervisorSolicitud')),  
  SupervisorSolicitudSubir : lazy(() => import('../../scenes/SupervisorSolicitudSubir')),
  SupervisorDetalleSolicitud: lazy(() => import('../../scenes/SupervisorSolicitud/scenes/detallesolicitud')),
  EjecutivoCobranzaAutorizacion: lazy(() => import('../../scenes/Autorizaciones')),
  EjecutivoCobranzaAutorizacionDetalle: lazy(() => import('../../scenes/Autorizaciones/scenes/detalleautorizacion')),
  EjecutivoSuscripcionConsulta: lazy(() => import('../../scenes/Subscription'))
}

const PrivateRoleRoute = (props: any) => {
  const [state, setstate] = useState([]);
  useEffect(() => {
    let roles:any;
    Auth.currentSession().then(async (res: any) => {
      const { idToken = {} } = res;
      const { payload } = idToken;
      roles = payload['cognito:groups'];
      if(roles){
        roles = roles.sort((a: any, b: any) => b.localeCompare(a));
        roles = [ ...roles ];
        const lessOneRol = helpers.lessOneRol(roles);
        if (lessOneRol.length === 0) {
          await Auth.signOut();
          localStorageClean();
        }
        localStorageSet('roles', lessOneRol);

        // *SONAR BUGS*  roles = [ ...roles ]
        let allowedRoutes = lessOneRol.reduce((acc: any, role: any) => {
          const rsp = rolesConfig.filter((obj: any) => {
            return role === obj.rol;
          });

          let respuestaFinal = [];
          if (rsp.length > 0) {
            respuestaFinal = rsp[0].routes;
          }
          return [...acc, ...respuestaFinal];
        }, []);
        if (!String(props.location.pathname).includes("/[object Object]")) {
          const esSuscriptor = lessOneRol.filter((obj: any) => {
            return obj === process.env.REACT_APP_ROL_SUSCRIPTOR_JEFE || obj === process.env.REACT_APP_ROL_SUSCRIPTOR_ANALISTA || obj === process.env.REACT_APP_ROL_SUSCRIPTOR_MEDICO;
          });
          const esSupervisor = lessOneRol.filter((obj: any) => {
            return obj === process.env.REACT_APP_ROL_SUPERVISOR;
          });
          const esCobranzas = lessOneRol.filter((obj: any) => {
            return obj === process.env.REACT_APP_ROL_COBRANZA;
          });
          const esSupervisorAgencia = lessOneRol.filter((obj: any) => {
            return obj === process.env.REACT_APP_ROL_SUPERVISOR_AGENCIA;
          });
          
          if (esSuscriptor.length > 0 && props.location.pathname === String(ROUTES.ROOT + ROUTES.SOLICITUDES)) {
            props.history.push(props.match.path + allowedRoutes[0].url);
          } else if (esSupervisor.length > 0 && props.location.pathname === String(ROUTES.ROOT + ROUTES.SOLICITUDES)) {
            props.history.push(props.match.path + allowedRoutes[0].url);
          } else if(esCobranzas.length > 0 && props.location.pathname === String(ROUTES.ROOT + ROUTES.SOLICITUDES)) {
            props.history.push(props.match.path + allowedRoutes[0].url);
          } else if(esSupervisorAgencia.length > 0 && props.location.pathname === String(ROUTES.ROOT + ROUTES.SOLICITUDES)) {
            props.history.push(props.match.path + allowedRoutes[0].url);
          } else {
            let result = allowedRoutes.filter((item: any) => {
              return (props.match.path + item.url) === props.location.pathname;
            });
            if (result.length === 0) {
              const esConsulta = lessOneRol.filter((obj: any) => {
                return obj === process.env.REACT_APP_ROL_CONSULTAS;
              });
              if (esConsulta.length > 0) {
                props.history.push(props.match.path + allowedRoutes[0].url);
              } else {
                props.history.push(ROUTES.ROOT);
              }              
            } else {
              props.history.push(props.match.path + result[0].url);
            }
          }
        }
        setstate(allowedRoutes);
      } else {
        props.history.push(ROUTES.ROOT);
      }
    })
  }, [])

  return (
    <Fragment>
      <Switch>
        {
          state.map((route: any, index: number) => {
            return (
              <PrivateRoute exact key={index} 
                component={detailComponents[route.component]} 
                path={`${props.match.path}${route.url}`} 
                parent={`${props.match.path}`}/>
            )
          })
        }
      </Switch>
    </Fragment>
  )
}

export default PrivateRoleRoute;
